// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__jfHsp","footer":"ReportModalFilter_footer__YrAdL"};